module.exports = __webpack_public_path__ + "static/teams-of-all-sizes-1bfaac250e255d4bfc13d007068e9a94.png";